import React, { useEffect } from 'react';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import { FormikProvider, useFormik } from 'formik';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { isEqual } from 'lodash';
import SendMessageForm from 'component/organism/workflow/forms/send-message-form/SendMessageForm';

const SendMessageModal = ({ isOpen, onClose, title, id, isError }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    setIsChanged,
    initialWorkflowData,
  } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      number: selectedNode?.whatsapp?.number || '',
      message: selectedNode?.whatsapp?.message || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      number: Yup.string().required('Required'),
      message: Yup.string().required('Required'),
    }),
    onSubmit: (values) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);

      if (initialNode) {
        const { message, number } = initialNode?.whatsapp || {};
        const initialWhatsappObject = {
          message: message || '',
          number: number || '',
        };

        const changed = !isEqual(values, initialWhatsappObject);

        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);

          if (changed && !alreadyExists) return [...prev, id];
          if (!changed && alreadyExists)
            return prev?.filter((nodeId) => nodeId !== id);

          return prev;
        });
      }
    },
  });

  const handleSubmit = async () => {
    try {
      // make sure validation runs now
      const errors = await formik.validateForm();
      if (Object.keys(errors || {}).length) {
        formik.setTouched({ number: true, message: true }, true);
      }

      const whatsappValues = {
        number: formik.values.number,
        message: formik.values.message,
      };

      const nextIsError =
        !whatsappValues.message || whatsappValues.message === '<p><br></p>';

      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                whatsapp: whatsappValues,
                is_Error: nextIsError,
              }
            : node,
        );

        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));

        onClose();
        formik.resetForm();
      }, 100);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <SendMessageForm id={id} />
      </FormikProvider>
    </RightSlider>
  );
};

export default SendMessageModal;
